import 'twin.macro';
import React from 'react';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';
import { FolderIcon as Folder } from '@heroicons/react/24/outline';
import { tagBackgroundColors, tagTextColor } from 'styles/userConstants';
import { css } from 'twin.macro';

export function FolderIcon(props: IconProps) {
  return (
    <Folder
      tw="p-1 rounded-lg"
      css={[
        css`
          background-color: ${tagBackgroundColors['kaki-quiet']};
          color: ${tagTextColor.kaki};
        `,
      ]}
      className={props.className}
      {...props}
    />
  );
}
